/**
 * Extrait un message lisible depuis `detail` (FastAPI / loyalty API).
 */
export function loyaltyApiDetail(detail) {
    if (detail == null) return null;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
        return detail
            .map((item) => {
                if (typeof item === "string") return item;
                if (item?.msg) return item.msg;
                return JSON.stringify(item);
            })
            .join(" ");
    }
    if (typeof detail === "object") {
        return detail.message || detail.detail || JSON.stringify(detail);
    }
    return String(detail);
}
